<template>
  <Modal title="Title" v-model="showLeadsModal" class-name="card-modal"
         :width="action==='view'?400:900">
    <div slot="header">
      <h4>{{title}}</h4>
    </div>

    <Form v-if="action==='edit'" ref="leadsProcessedForm" :model="leadsProcessedForm">
      <Row class="widget-container">

        <!--Questions on the left-->
        <i-col :xs="12" :sm="12" :md="12" :lg="12">
          <FormItem v-for="(question, index) in leadsProcessedForm.questions"
                    :key="index" :prop="'questions[' + index + '].label'"
                    v-if="index % 2 !== 0 && question.status
                    && question.type.toLowerCase().indexOf('textarea') < 0
                    && question.fieldCode.toLowerCase().indexOf('rating') < 0">
            <Row>
              <i-col :xs="24" :sm="24" :md="24" :lg="24">
                <div class='full-input'>
                  <label class="label-answer" :for="question.questionId">
                    {{leadsProcessedForm.questions[index].label}}
                  </label>
                  <FormItem v-for="(answer, ix) in question.answers" :key="ix" label=""
                            :prop="'questions[' + index + '].answers[' + ix + '].answerValue'">
                    <Row>
                      <table border="0" class="w-100">
                        <tr>
                          <td>
                            <Select @on-change="(e) => changeType(question.questionId, ix, e)"
                                    v-if="question.choices.length>0||question.inputType=='radioList'||
                                question.inputType=='multiChoice'||question.inputType=='singleChoice'"
                                    placeholder="Select One" v-model="answer.answerValue">
                              <Option v-for="c in question.choices" :key="c.label" :value="c.label">
                                {{c.label}}
                              </Option>
                            </Select>
                            <input :readonly="question.choices.length>0"
                                   style="width: 100%;" type='text' class="input-answer"
                                   :name='question.questionId' v-model="answer.answerValue">
                            </input>
                          </td>
                          <td v-if="answer.others!=null">
                            <input v-if="answer.others!=null"
                                   placeholder="others..." style="width: 100%;"
                                   type='text' class="input-answer"
                                   v-model="answer.others">
                            </input>
                          </td>
                        </tr>
                      </table>
                    </Row>
                  </FormItem>
                </div>
              </i-col>
            </Row>
          </FormItem>
        </i-col>

        <!--Questions on the right-->
        <i-col :xs="12" :sm="12" :md="12" :lg="12">
          <FormItem v-for="(question, index) in leadsProcessedForm.questions"
                    :key="index" :prop="'questions[' + index + '].label'"
                    v-if="index % 2 === 0 && question.status
                    && question.type.toLowerCase().indexOf('textarea') < 0
                    && question.fieldCode.toLowerCase().indexOf('rating') < 0">
            <Row>
              <i-col :xs="24" :sm="24" :md="24" :lg="24">
                <div class='full-input'>
                  <label class="label-answer" :for="question.questionId">
                    {{leadsProcessedForm.questions[index].label}}
                  </label>
                  <FormItem v-for="(answer, ix) in question.answers" :key="ix" label=""
                            :prop="'questions[' + index + '].answers[' + ix + '].answerValue'">
                    <Row>
                      <table border="0" style="width: 100%">
                        <tr>
                          <td align="left" valign="top">
                            <Select @on-change="(e) => changeType(question.questionId, ix, e)"
                                    v-if="question.choices.length>0||question.inputType==='radioList'||
                                    question.inputType==='multiChoice'||question.inputType==='singleChoice'"
                                    v-model="answer.answerValue" :multiple="question.inputType==='multiChoice'">
                              <Option v-for="c in question.choices" :key="c.label" :value="c.label">{{c.label}}
                              </Option>
                            </Select>
                            <input :readonly="question.choices.length>0"
                                   style="width: 100%;" type='text' class="input-answer"
                                   :name='question.questionId' v-model="answer.answerValue">
                            </input>
                          </td>
                          <td v-if="answer.others!=null" align="left" valign="top">
                            <input v-if="answer.others!=null"
                                   placeholder="others..." style="width: 100%; border: 1px solid darkgrey;"
                                   type='text' class="input-answer"
                                   v-model="answer.others">
                            </input>
                          </td>
                        </tr>
                      </table>
                    </Row>
                  </FormItem>
                </div>
              </i-col>
            </Row>
          </FormItem>
        </i-col>

        <!--Comment-->
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem v-for="(question, index) in leadsProcessedForm.questions"
                    :key="index" :prop="'questions[' + index + '].label'"
                    v-if="question.status
                    && question.type.toLowerCase().indexOf('textarea') > -1">
            <Row style="min-height: 50px; display: block">
              <i-col :xs="24" :sm="24" :md="24" :lg="24">
                <div class='full-input'>
                  <label class="label-answer" :for="question.questionId">
                    {{leadsProcessedForm.questions[index].label}}
                  </label>
                  <FormItem v-for="(answer, ix) in question.answers" :key="ix" label=""
                            :prop="'questions[' + index + '].answers[' + ix + '].answerValue'">
                    <Row>
                      <Input type="textarea" :autosize="{minRows: 5,maxRows: 10}"
                             placeholder="..." class="input-answer"
                             v-model="answer.answerValue">
                      </Input>
                    </Row>
                  </FormItem>
                </div>
              </i-col>
            </Row>
          </FormItem>
        </i-col>

        <!--Lead Rating-->
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem v-for="(question, index) in leadsProcessedForm.questions"
                    :key="index" :prop="'questions[' + index + '].label'"
                    v-if="question.status
                    && question.fieldCode.toLowerCase().indexOf('rating') > -1">
            <Row style="min-height: 50px; display: block">
              <i-col :xs="24" :sm="24" :md="24" :lg="24">
                <div class='full-input'>
                  <label class="label-answer" :for="question.questionId">
                    {{leadsProcessedForm.questions[index].label}}
                  </label>
                  <FormItem v-for="(answer, ix) in question.answers" :key="ix" label=""
                            :prop="'questions[' + index + '].answers[' + ix + '].answerValue'">
                    <Row>
                      <i-col :xs="8" :sm="8" :md="8" :lg="8" align="center">
                        <Button id="hotbtn" @click="(e)=> changeLeadType(index, ix, e)"
                                name="Hot" title="HOT" size="large"
                                :class="answer.answerValue=='HOT'?hotBtnClicked: hotBtn">
                        </Button>
                      </i-col>
                      <i-col :xs="8" :sm="8" :md="8" :lg="8" align="center">
                        <Button id="warmbtn" @click="(e)=> changeLeadType(index, ix, e)"
                                name="Warm" title="WARM" size="large"
                                :class="answer.answerValue=='WARM'?warmBtnClicked: warmBtn">
                        </Button>
                      </i-col>
                      <i-col :xs="8" :sm="8" :md="8" :lg="8" align="center">
                        <Button id="coldbtn" @click="(e)=> changeLeadType(index, ix, e)"
                                name="Cold" title="COLD" size="large"
                                :class="answer.answerValue=='COLD'?coldBtnClicked: coldBtn">
                        </Button>
                      </i-col>
                    </Row>
                  </FormItem>
                </div>
              </i-col>
            </Row>
          </FormItem>
        </i-col>
      </Row>
    </Form>

    <Form v-if="action==='view'" ref="leadsProcessedForm" :model="leadsProcessedForm" class="k4-viewOnlyForm">
      <Row class="widget-container">
        <FormItem v-for="(question, index) in leadsProcessedForm.questions"
                  :key="index" :prop="'questions[' + index + '].label'"
                  v-if="question.status
                  && question.type.toLowerCase().indexOf('textarea') < 0
                  && question.fieldCode.toLowerCase().indexOf('rating') < 0">
          <Row>
            <i-col :xs="24" :sm="24" :md="24" :lg="24">
              <div class='full-input-viewOnly'>
                <label class="label-answer" :for="question.questionId">
                  {{leadsProcessedForm.questions[index].label}}
                </label>
                <FormItem v-for="(answer, ix) in question.answers" :key="ix" label=""
                          :prop="'questions[' + index + '].answers[' + ix + '].answerValue'">
                  <Row>
                    <input readonly style="width: 100%;" type='text' class="input-answer" v-model="answer.answerValue" />
                  </Row>
                </FormItem>
              </div>
            </i-col>
          </Row>
        </FormItem>
        <FormItem v-for="(question, index) in leadsProcessedForm.questions"
                  :key="index" :prop="'questions[' + index + '].label'"
                  v-if="question.status && question.type.toLowerCase().indexOf('textarea') > -1">
          <Row>
            <i-col :xs="24" :sm="24" :md="24" :lg="24">
              <div class='full-input-viewOnly'>
                <label class="label-answer" :for="question.questionId">
                  {{leadsProcessedForm.questions[index].label}}
                </label>
                <FormItem v-for="(answer, ix) in question.answers" :key="ix" label=""
                          :prop="'questions[' + index + '].answers[' + ix + '].answerValue'">
                  <Row>
                    <Input readonly type="textarea" :autosize="{minRows: 5,maxRows: 10}"
                           placeholder="..." v-model="answer.answerValue">
                    </Input>
                  </Row>
                </FormItem>
              </div>
            </i-col>
          </Row>
        </FormItem>
        <FormItem v-for="(question, index) in leadsProcessedForm.questions"
                  :key="index" :prop="'questions[' + index + '].label'"
                  v-if="question.status && question.fieldCode.toLowerCase().indexOf('rating') > -1">
          <Row>
            <i-col :xs="24" :sm="24" :md="24" :lg="24">
              <div class='full-input-viewOnly'>
                <label class="label-answer" :for="question.questionId">
                  {{leadsProcessedForm.questions[index].label}}
                </label>
                <FormItem v-for="(answer, ix) in question.answers" :key="ix" label=""
                          :prop="'questions[' + index + '].answers[' + ix + '].answerValue'">
                  <Row>
                    <i-col :xs="8" :sm="8" :md="8" :lg="8" align="center">
                      <Button disabled name="Hot" title="HOT" size="large"
                              :class="answer.answerValue.toUpperCase()=='HOT'?hotBtnClicked: hotBtn">
                      </Button>
                    </i-col>
                    <i-col :xs="8" :sm="8" :md="8" :lg="8" align="center">
                      <Button disabled name="Warm" title="WARM" size="large"
                              :class="answer.answerValue.toUpperCase()=='WARM'?warmBtnClicked: warmBtn">
                      </Button>
                    </i-col>
                    <i-col :xs="8" :sm="8" :md="8" :lg="8" align="center">
                      <Button disabled name="Cold" title="COLD" size="large"
                              :class="answer.answerValue.toUpperCase()=='COLD'?coldBtnClicked: coldBtn">
                      </Button>
                    </i-col>
                  </Row>
                </FormItem>
              </div>
            </i-col>
          </Row>
        </FormItem>
      </Row>
    </Form>

    <div slot="footer">
      <Button class="btn btn-outline-secondary btn-sm" @click="handleResetLeadForm();showLeadsModal=false"
              style="margin-left: 8px">Cancel
      </Button>
      <Button
        class="submit btn btn-success btn-sm" @click="handleCreateLeadForm('leadsProcessedForm')"
        v-if="action=='add'">Create
      </Button>
      <Button class="submit btn btn-success btn-sm" v-if="action=='edit'"
              @click="handleUpdateLeadForm('leadsProcessedForm',leadsProcessedForm.leadFormId)">Save
      </Button>
    </div>
  </Modal>
</template>
<script>
  import {addLeadForm, updateLeadForm} from "../../services/LeadForms.service";
  import TimeSpinner from "iview/src/components/date-picker/base/time-spinner";
  //import {bus} from '../../../main'

  export default {
    components: {TimeSpinner},
    data() {
      return {
        index: 0,
        action: 'add',
        title: 'ADD LEAD FORM',
        showLeadsModal: false,
        leadsProcessedForm: {
          index: 0,
          status: 0,
          isReadOnly: '',
          canDelete: '',
          leadFormId: '',
          formId: 0,
          leadId: '',
          formName: '',
          firstName: '',
          lastName: '',
          email: '',
          questions: [{
            questionId: '',
            formId: '',
            label: '',
            type: '',
            inputType: '',
            headerTag: '',
            fieldCode: '',
            order: '',
            visible: '',
            answer: {
              questionId: '',
              answerType: '',
              answerValue: '',
              fieldCode: ''
            }
          }]
        },
        indeterminate: null,
        checkAll: false,
        hotBtn: 'hotButton',
        warmBtn: 'warmButton',
        coldBtn: 'coldButton',
        hotBtnClicked: 'hotBtnClicked',
        warmBtnClicked: 'warmBtnClicked',
        coldBtnClicked: 'coldBtnClicked',
      }
    },
    methods: {
      openLeadsProcessedForm(title, action) {
        this.handleResetLeadForm();
        this.showLeadsModal = true;
        this.title = title;
        this.action = action;
      },
      setFormValue(params, index) {
        let data = Object.assign({}, params);
        delete data['_index'];
        delete data['_rowKey'];
        this.leadsProcessedForm = data;
      },
      handleResetLeadForm() {
        //this.$refs['leadsProcessedForm'].resetFields();
        let self = this;
        Object.keys(this.leadsProcessedForm).forEach(function (key) {
          self.leadsProcessedForm[key] = null;
        });
      },
      handleCreateLeadForm(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let companyObj = JSON.parse(localStorage.getItem('selected_company'));
            let company = null;
            if (!companyObj) {
              company = companyObj.companyName;
            }
            const data = Object.assign({}, this.leadsProcessedForm);
            data['formId'] = data.formId;
            data['leadFormId'] = data.leadFormId;
            data['leadId'] = data.leadId;
            data['formName'] = data.formName;
            data['firstName'] = data.firstName;
            data['lastName'] = data.lastName;
            data['email'] = data.email;
            data['createdBy'] = data.createdBy
            data['createdDate'] = data.createdDate;
            this.showLeadsModal = false
            addLeadForm(data).then(response => {
              data['leadFormId'] = response.data.leadFormId;
              this.$emit('addLeadForm', data);
              this.$Message.success('Lead Form successfully added!');
            }).catch(error => {
              console.log(error.response)
              if (error.response.request.responseText) {
                let errResponse = JSON.parse(error.response.request.responseText)
                Object.keys(errResponse).map(key => {
                  errResponse[key].map(errMsg => {
                    this.$Message.error(errMsg);
                  })
                })
              } else {
                this.$Message.error('Failed adding lead form');
              }
            })
          }
        })
      },
      handleUpdateLeadForm(name, leadFormId) {
        let formData = {};
        formData.questions = [];
        formData.answers = [];
        this.leadsProcessedForm.questions.map(q => {
          let fieldCode = "";
          if (q.label) {
            fieldCode = q.label.replace('.', '').replace(/\s/g, '-');
          }
          let questionData = {};
          questionData.questionId = q.questionId;
          questionData.formId = this.leadsProcessedForm.formId;
          questionData.title = q.title;
          questionData.type = q.type;
          questionData.headerTag = q.headerTag;
          questionData.inputType = q.inputType;
          questionData.fieldCode = q.fieldCode == null ? fieldCode : q.fieldCode;
          questionData.order = q.order;
          questionData.visible = q.visible;
          questionData.choices = q.choices;
          formData.questions.push(questionData);

          q.answers.map(a => {
            let answerData = {};
            answerData.questionId = a.questionId;
            answerData.answerType = a.answerType;
            answerData.answerValue = a.answerValue;
            answerData.fieldCode = a.fieldCode == null ? fieldCode : a.fieldCode;
            formData.answers.push(answerData);
          }, []);
        }, []);
        this.leadsProcessedForm.questions = formData.questions;
        this.leadsProcessedForm.answers = formData.answers;
        this.$refs['leadsProcessedForm'].validate((valid) => {
          if (valid) {
            this.showLeadsModal = false;
            const data = Object.assign({}, this.leadsProcessedForm);
            updateLeadForm(leadFormId, data).then(response => {
              this.$emit('updateLeadForm', leadFormId, data);
              this.$Message.success('Lead Form successfully update!');
            }).catch(error => {
              this.$Message.error('Failed updating lead form');
            })
          }
        })
      },
      changeType(questionId, answerIX, choiceLabel) {
        this.leadsProcessedForm.questions
          .filter(a => a.questionId == questionId)[0].answers[answerIX].answerType = 'string';
        this.leadsProcessedForm.questions
          .filter(a => a.questionId == questionId)[0].answers[answerIX]
          .answerValue = choiceLabel;
      },
      changeLeadType(index, ix, e) {
        if (e.target.id == 'hotbtn') {
          this.leadsProcessedForm.questions[index].answers[ix].answerValue = 'HOT';
          this.leadsProcessedForm.questions[index].answers[ix].answerType = 'string';
          e.target.classList.remove("hotButton");
          e.target.classList.remove("ivu-btn");
          e.target.classList.remove("ivu-btn-default");
          e.target.classList.add("hotBtnClicked");
        }
        if (e.target.id == 'warmbtn') {
          this.leadsProcessedForm.questions[index].answers[ix].answerValue = 'WARM';
          this.leadsProcessedForm.questions[index].answers[ix].answerType = 'string';
          e.target.classList.remove("warmButton");
          e.target.classList.remove("ivu-btn");
          e.target.classList.remove("ivu-btn-default");
          e.target.classList.add("warmBtnClicked");
        }
        if (e.target.id == 'coldbtn') {
          this.leadsProcessedForm.questions[index].answers[ix].answerValue = 'COLD';
          this.leadsProcessedForm.questions[index].answers[ix].answerType = 'string';
          e.target.classList.remove("coldButton");
          e.target.classList.remove("ivu-btn");
          e.target.classList.remove("ivu-btn-default");
          e.target.classList.add("coldBtnClicked");
        }
        return false;
      },
      setColors() {
        setTimeout(function () {

        }, 1000);
      }
    }
  }
</script>

<style scoped>
  .k4-viewOnlyForm {
    pointer-events: none;
  }
  .full-input {
    display: inline-block;
    width: 100%;
    padding: 3px;
    border: 1px solid darkgrey;
    border-radius: 4px;
    width: 100%;
  }

  .full-input-viewOnly {
    display: inline-block;
    width: 100%;
    padding: 1px;
    border: 1px solid darkgrey;
    border-radius: 4px;
    width: 100%;
  }

  .ivu-input, .ivu-btn {
    border: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/c_LeadsProcessed/_LeadsProcessedForm.vue